/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Ryd valgte',
  'paginated-picker.async-select.menu-list.error-message.error-message': 'Data kunne ikke hentes',
  'paginated-picker.async-select.menu-list.error-message.retry-message': 'Klik for at prøve igen',
  'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Indlæser ...',
  'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Vis mere',
  'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} af {totalCount}',
  'paginated-picker.async-select.select.no-options-message.no-options-message': 'Ingen match fundet',
  'paginated-picker.async-select.select.option.error-message': 'Data kunne ikke hentes',
  'paginated-picker.async-select.select.option.retry-message': 'Klik for at prøve igen',
  'paginated-picker.async-select.select.search-placeholder': 'Søg',
  'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Vis hele listen'
};